import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ivclass from '../../Modules/IVClass';
import { memo } from 'react';
import { AssetsAppName, CheckboxChecked, CheckboxUnchecked, ChevronDownIcon, ChevronUpIcon, getWebAssetsUrl, PremiumIcon, } from '../../utils/web-assets';
const toDisplayNumber = (count) => {
    if (!count || count < 0) {
        return null;
    }
    else if (count < 1000) {
        return count.toString();
    }
    else if (count < 1000000) {
        return (count / 1000).toFixed(1) + 'K';
    }
    else {
        return (count / 1000000).toFixed(1) + 'M';
    }
};
const truncateText = (str) => {
    if (str.length > 25) {
        return `${str.substring(0, 25)}...`;
    }
    return str;
};
const LowerLevelFilter = ({ filter, onFilterSelected, onFilterCollapsed, onClearAll, level, query = '', parentKey = '', }) => {
    const premiumIconUrl = getWebAssetsUrl(PremiumIcon, AssetsAppName.LIHP);
    const { name, collapsed, count, selected, enabled } = filter;
    const countText = `${count}`;
    const searchRegex = new RegExp(query, 'gi');
    if (!searchRegex.test(name)) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", { children: [_jsxs("div", { className: ivclass(enabled ? 'iv-opacity-100 iv-cursor-default' : 'iv-opacity-50', 'iv-flex iv-flex-row iv-items-center iv-mb-10'), children: [_jsxs("label", { className: "!iv-m-[0px] iv-flex iv-pl-[5px]", children: [_jsx("input", { type: "checkbox", className: "iv-mr-10 iv-accent-grey-100 iv-hidden", checked: selected === true ? true : false, onChange: e => onFilterSelected(filter, !selected, parentKey) }), !selected ? (_jsx("img", { className: "iv-h-[16px] iv-w-[16px] iv-mr-[6px]", src: getWebAssetsUrl(CheckboxUnchecked, AssetsAppName.LIHP), alt: "filter unchecked" })) : (_jsx("img", { className: "iv-h-[16px] iv-w-[16px] iv-mr-[6px]", src: getWebAssetsUrl(CheckboxChecked, AssetsAppName.LIHP), alt: "filter checked" }))] }), _jsx("div", { className: ivclass('iv-text-body-m iv-font-medium', selected ? 'iv-text-grey-85' : 'iv-text-grey-60', 'hover:iv-text-grey-85'), onClick: e => onFilterSelected(filter, !selected, parentKey), children: truncateText(name) }), name === 'Premium' && (_jsx("img", { src: premiumIconUrl, className: 'iv-ml-[8px] iv-mt-[-4px]' })), collapsed !== null && query === '' ? (_jsx("img", { alt: "", src: getWebAssetsUrl(collapsed ? ChevronDownIcon : ChevronUpIcon, AssetsAppName.LIHP), onClick: e => onFilterCollapsed(filter, !collapsed) })) : null] }), (!collapsed || query !== '') && (_jsx("div", { style: { marginLeft: `${level * 25}px` }, children: filter.filters.map((f, i) => (_jsx(LowerLevelFilter, { filter: f, onClearAll: onClearAll, onFilterSelected: onFilterSelected, onFilterCollapsed: onFilterCollapsed, level: level + 1, parentKey: "" }, i))) }))] }));
};
export default memo(LowerLevelFilter);
